import { render } from "./Typo3ApiPage.vue?vue&type=template&id=f6edc2d2&scoped=true"
import script from "./Typo3ApiPage.vue?vue&type=script&lang=js"
export * from "./Typo3ApiPage.vue?vue&type=script&lang=js"

import "./Typo3ApiPage.vue?vue&type=style&index=0&id=f6edc2d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6edc2d2"]])

export default __exports__